import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
    background: linear-gradient(135deg, rgb(13, 13, 38) 0%, rgb(26, 26, 51) 100%);
    background-attachment: fixed;
    min-height: 100vh;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  section {
    padding: 4rem 2rem;
  }

  section h2 {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 700;
  }

  .cta-button {
    display: inline-block;
    background: linear-gradient(135deg, #7359B3 0%, #593399 100%);
    color: white;
    padding: 1rem 2.5rem;
    border-radius: 16px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 1.1rem;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    height: 56px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .cta-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
  }

  .cta-button.white {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.95);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
  }

  .cta-button.white:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  /* Responsive */
  @media (max-width: 768px) {
    section h2 {
      font-size: 2rem;
    }
    
    .container {
      padding: 0 1rem;
    }
  }
`;
